<template>
  <div class="file-image-background-container">
    <div class="file-image-background" v-on:click="$emit('open-gallery', index)">
      <div class="file-image-container">
        <img src="../../assets/images/gray-ratio3x2.png" :alt="file.title" v-if="!file.thumbnailUrl" />
<!--        <img :src="`https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQvCqDynskW6im548oTDHiV6Ayt8t5fem-JJd5mgwOHB8MNIIzT`" :alt="file.title" v-if="file.thumbnailUrl">-->
        <img :src="`${baseUrl}${file.thumbnailUrl}`" :alt="file.title" v-if="file.thumbnailUrl">
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../config'

  export default {
    name: "UXFolderFileImage",
    props: {
      file: Object,
      index: Number
    },
    data() {
      return {
        baseUrl: config.baseUrl
      }
    }
  };
</script>
